
import ChartsEmbedSDK, {
  getRealmUserToken,
} from "@mongodb-js/charts-embed-dom";
import * as Realm from "realm-web";

//transfer client from login page
const client = require("./index.js");

document
  .getElementById("logoutButton")
  .addEventListener("click", () => logOut()); 


var sdk = new ChartsEmbedSDK({
  baseUrl: "https://charts.mongodb.com/charts-mdb_edu-fmdbf", 
  getUserToken: () => getRealmUserToken(client),
});

//allow for unauthenticated access to IHE charts 
if(window.location.pathname.startsWith("/InsideHigherEd/AnnualSurvey")){
  console.log("inside higher ed");
   sdk = new ChartsEmbedSDK({
    baseUrl: "https://charts.mongodb.com/charts-mdb_edu-fmdbf",
  });
}

// initialize info for higher ed dashboard (first string = id of target div, second list of strings = chart ids)
const higherEd_ids = [["feedback_chart",["10e7ffd1-4348-4589-9f9b-47ad9b9b1418"]], 
                      ["in_office_chart",["c39fb5eb-1ee3-4062-9fdc-41669263b988"]],
                      ["relationship_chart",["370a71dd-409f-4ce6-9913-6c84905641ac"]],
                      ["advice_chart",["aab053a7-f485-4968-b458-d4aff682ffdc"]], 
                      ["culture_chart",["9e8ace90-e900-44d1-9ff1-e0b7d5f24608"]],
                      ["colleagues_chart",["53d5d9e5-b6e8-40e6-ad44-b75a41390afa"]], 
                      ["job_sites_chart",["c120714c-6c0a-4dc8-ac21-7ef545edb169"]],
                      ["sample_size_chart",["65df81ca-3e2b-479e-89b2-51a097635503"]]
                    ];

const higherEdPlaybook_issues_ids = [["top_campus_issues",["65d36d90-02ee-4790-88d0-a5099baa59e9"]], 
                                      ["campus_student_views",["65d1f658-c3e9-4ab1-8597-bd1ecd3f709b","65d1f7bc-db6b-4d50-8ac0-8b10c815ee9f"]],
                                      ["top_national_issues",["65d3e524-abaa-464d-8835-c6ee88418bf7"]],
                                      ["national_student_views",["65d1fb0e-483d-4aca-800e-d80112f264a2"]]];  // looks like there should be another chart here, but it is not listed in the ppt

const higherEdPlaybook_actions_ids = [["on_campus_issues",["65d36a15-a41c-45a3-84ec-775ed5aca458","65d36c81-a41c-46b5-81ec-775ed5d23f0c"]],
                                      ["national_issues",["65d1f8fd-1618-46c6-8715-f59cfd54893b","65d1f991-6667-4a49-85cd-e699d51b6fec"]]];  

const higherEdPlaybook_messages_ids = [["statue",["65d90f87-5abb-4618-821e-21f072a2f43d"]], 
                                        ["firing",["ec914403-b389-44e2-bee3-3aa8e8300e98"]], 
                                        ["climate",["65d90e9e-4a68-4fec-8245-ce9759c43bb1"]],
                                        ["debt",["65d9101d-4a68-4cd5-8b5c-ce9759ec76d8"]]];  

const higherEdPlaybook_message_examples = {
  "statue": {"Indignant":'“We condemn in the strongest terms the reprehensible act of graffitiing a racial slur on a statue, and we will ensure the responsible party faces appropriate consequences for their hateful actions.”',
             "Compassionate":'“We are deeply saddened by the hurt caused by the graffiti incident, and we stand in solidarity with the affected communities; we will take immediate action to foster a campus environment that is inclusive, respectful, and supportive for all.”',
             "Inspirational":'“In the face of adversity, we will rise together as a united community, committed to eradicating hate and embracing the values of diversity and equality; let us turn this incident into an opportunity to build a stronger, more inclusive campus for all.”',
             "Accountable":'“As a university, we take responsibility for this incident, and we recognize the need for comprehensive actions that promote education, awareness, and dialogue to prevent such incidents in the future.”'
            },
  "firing": {"Indignant":'“We stand firmly by our decision to terminate Professor Hayes. This action reflects our unwavering commitment to uphold the highest standards of conduct and integrity within our academic community. We will not tolerate behavior that contradicts our institution’s values and mission.”',
             "Compassionate":'“The termination of Professor Hayes has deeply affected our campus community. We extend our heartfelt sympathies to all impacted by this event and commit to healing and rebuilding trust within our academic family.”',
             "Inspirational":'“While the departure of Professor Hayes is a challenging moment for us, it serves as a catalyst for reflection and growth. Let us unite to reaffirm our commitment to the values of education and the pursuit of knowledge.”',
             "Accountable":'“We recognize the concerns raised by the termination of Professor Hayes and the need for transparency. We are committed to reviewing our policies and procedures to ensure that our actions align with our mission and the expectations of our community.”'
            },
  "climate": {"Indignant":'“We vehemently denounce the continuous ignorance and inaction towards climate change, and we will not stand idly by. Those who contribute to this global crisis through negligence or denial must be held accountable for endangering our planet.”',
              "Compassionate":'“We are heartbroken to witness the devastating impact of climate change on vulnerable populations and ecosystems. Our institution pledges to support sustainability efforts and provide aid to those affected, fostering a culture of care and stewardship for our Earth.”',
              "Inspirational":'“In this pivotal moment, we have the opportunity to lead the charge against climate change. Together, we can ignite a transformation towards a sustainable future, empowering our community to innovate and act with courage and determination.”',
              "Accountable":'“We acknowledge our role in contributing to climate change and the urgent need for action. It is our duty to implement environmentally responsible practices and to educate our community on the importance of sustainability, ensuring a livable world for generations to come.”'
            },
  "debt": {"Indignant":'“We fiercely criticize the crippling burden of student debt that hinders the progress of our nation’s brightest minds. It is unacceptable for education to be a gateway to financial hardship, and we demand immediate reform to alleviate this unjust burden.”',
           "Compassionate":'“The weight of student debt on our graduates is a matter of deep concern. We empathize with those struggling under its load and commit to advocating for solutions that ease this financial strain, ensuring education remains a beacon of hope and opportunity.”',
           "Inspirational":'“Let us envision a future where education is a right, not a privilege burdened by debt. We call upon our community to rally together, to innovate and strive for a world where every student can pursue their dreams unencumbered by financial barriers.”',
           "Accountable":'“We acknowledge the significant impact of student debt on our students’ futures. As an institution, we are dedicated to exploring every avenue to reduce this burden, including financial counseling, debt relief programs, and advocating for policy changes at the national level.”'
            }
}
                            
const scores_ids = [["nameid_dashboard",["7689aff5-6ea5-4471-a412-3d4f51cce24f","c0480922-1c44-478e-89b3-b8823e10f291"]],
                    ["favorability_dashboard",["6501f83b-e7c2-40d6-8e5a-6e72df18306a","65088a87-396d-429d-8e6a-849e27bd25e8"]],
                    ["employee_life_dashboard",["650a00b8-13b2-4c19-8496-aba38ba88b6b","650a0184-8a91-4421-8c89-c27d72094421"]],
                    ["belonging_dashboard",["6509f720-73e9-42df-8a22-2d4da453913d","6509f82c-cd71-4fd7-81b5-699a91f3d143"]],
                    ["apply_interest_dashboard",["6509f254-cd71-449c-83d8-699a91eca2cd","6509f3e9-ab57-47de-8aa0-2561d8c2b4ea"]]] 

const insideHigherEd_ids = [["value",["663153a2-42eb-4a96-8596-40324a69d955"]],
                            ["affordability-pct-y",["20732fe9-e47c-4232-89cf-91d317ef6a47"]],
                            ["operational_cost-pct-x",["0cba569a-d9ed-42bc-8397-9065a00f645f"]],
                            ["price_cut-pct-y",["616a4e27-7f67-4cce-9825-0ff4c3b1bf50"]],
                            ["FAFSA_concern",["66312c5a-4d8a-4797-82ce-f15c4774ad9e"]],
                            ["FAFSA_comms",["66312d4f-5cf2-4806-84e7-6e20016979d7"]],
                            ["sample_size_chart",["66384b09-89f7-433d-8d96-6fe564c63a35"]]
                          ]

const insideHigherEdAnnualSurvey_ids = [
                                        // Academic Life
                                        ["q1", ["6655cc24-10ed-4072-8c1b-088899ab78da"]],
                                        ["q2-pct-x", ["6657501a-102a-45d9-821e-f083ee350c02"]], // *
                                        ["q3-pct-y", ["6655fbe6-9cb4-40c2-82a7-cffe9dd0351b"]], // *
                                        ["q4-pct-x", ["66575055-b59d-4fee-8c1c-353099394b62"]], // * 
                                        ["q5-pct-y", ["66585acf-8e37-49e5-821c-dc7256e49dab"]], // *
                                        ["q6-pct-y", ["6658604b-f0d1-4a8d-8e08-1f4f0edf96d4"]], // *
                                        // Health and Wellness
                                        ["q7", ["6655d8c8-5c48-4717-8929-20d8ff9aa168"]], // "how do you rate the following (mental health, etc.)"
                                        ["q8-pct-x", ["665deec8-b67a-458f-8f7b-2a256406bae2"]], // *
                                        ["q9", ["6655da49-9cb4-40e1-81ff-cffe9d45d125"]],
                                        ["q10-pct-x", ["66586378-3075-4e4e-8164-b01bb549e02d"]], // * 
                                        ["q11-pct-x", ["66586f96-d694-4b55-8b56-77ff97af8a05"]], // * 
                                        // College Experience
                                        ["q12", ["6655dbbb-78d8-415e-8c6b-ca063dfff0fd"]], 
                                        ["q13", ["6655dd83-671e-4c79-8f9a-8646518d5c63"]],
                                        ["q14", ["6655df5f-10ed-478d-81eb-08889938a02d"]],
                                        ["q15-pct-x", ["66586fe4-686b-48e8-8ff0-0aed63d88513"]], // *
                                        ["q16", ["6655f4d7-10ed-4396-8480-08889964ccc8"]],
                                        ["q16b", ["6655f5f5-0816-4a7c-85da-048d78426007"]],
                                        ["q16c", ["06df79ba-ab48-4bba-bf12-a7374651ca33"]], // STILL HAVE TO REMOVE FROM HTML // If no/not sure, imagine you are a customer (was this combined with if yes?)
                                        ["q17", ["6655f6f2-e52a-4151-8c0b-0cbf4aa25f59"]],
                                        ["q18", ["6655f7e8-9ee1-402f-87ea-3f5a3d418180"]],
                                        ["q19", ["6655f887-4ae7-4980-8c5e-12caaae156c8"]],
                                        // Life After College
                                        ["q20-pct-x", ["665875fa-5f3d-48b2-82a8-627aa58bca49"]], // *
                                        ["q21-pct-x", ["6658795b-6153-4da0-8c3b-e6b73fe5ccd4"]], // * 
                                        ["q22", ["6655f998-9cb4-49ed-85f2-cffe9db21ed5"]],
                                        ["q23-pct-y", ["66587afc-6ad9-42e9-801b-6cd1687f11f8"]], // * 
                                        ["q24", ["6655fa90-e0b5-46fc-8038-69c2d66cf1a3"]],
                                        ["q25", ["6655fb71-9ee1-463f-84a2-3f5a3d6f403a"]],
                                        // Sample Size
                                        ["sample_size_chart", ["6655f956-1f8d-46a8-8ed5-012850d00b17"]]
                                      ];             

const letsGrowMI_ids = [["recent_move",["6618228c-6be8-4d1f-8762-c6960ecb97a2"]],
                        ["current_learn",["661d37da-32a0-4f43-856d-ee8bdfeb1248"]],
                        ["current_plan",["661d3857-32a0-4065-829d-ee8bdff3be1b"]],
                        ["current_satisfaction",["6620305a-3fe7-4d7c-80d2-03fa26536d53"]],
                        ["current_challenges-pct-y",["66340ab3-6c9f-4a08-8e38-4349a7c4ddd9"]],
                        ["current_factors-pct-x",["6627e6c2-20fa-4db6-8400-e4bfcb572088"]],
                        ["move_factors",["662310a9-5bbc-4192-8440-c934d42163ec"]],
                        ["kids",["661dabb5-986b-4b00-8ebb-10d0d9a4d501"]],
                        ["relocation_reason",["6627e84d-5bbc-44ac-83dd-c934d48a4cfb"]],
                        ["destination-pct-x",["6627f5f3-e00d-487d-882d-e5a5989d5c6b"]],
                        ["relocation_factors",["6627f17c-786f-433c-8648-8ef5e0e4227e"]],
                        ["statements",["6627e3e2-beed-4ce0-8466-b3c5f5907236"]],
                        ["sample_size_chart",["66384c5d-65a2-4b14-863f-b17cfb1dc277"]]
                      ]

// Pass the value from entry_page to the dashboard dropdown
const urlParams = new URLSearchParams(window.location.search);
const selectedAudience = urlParams.get("audience");
if (selectedAudience) {
    document.getElementById("audience").value = selectedAudience;
}

// Make the correct link active on header and display dashboards 
(async function() {
  if(window.location.pathname.startsWith("/workplace_dashboard")){
    document.querySelector("a[href='/workplace_dashboard.html']").classList.add("active");
    await displayWorkplaceDash(sdk);
  }else if (window.location.pathname.startsWith("/scores_dashboard")){
    document.querySelector("a[href='/scores_dashboard.html']").classList.add("active");
    await displayDash(scores_ids);
  }else if (window.location.pathname.startsWith("/higher_ed_playbook_issues")){
    const links = document.querySelectorAll("a[href='/higher_ed_playbook_issues.html']")
    links.forEach(link => link.classList.add("active"));
    await displayDash(higherEdPlaybook_issues_ids);
  }else if (window.location.pathname.startsWith("/higher_ed_playbook_actions")){
    const links = document.querySelectorAll("a[href='/higher_ed_playbook_actions.html']")
    links.forEach(link => link.classList.add("active"));  
    await displayDash(higherEdPlaybook_actions_ids);
  }else if (window.location.pathname.startsWith("/higher_ed_playbook_messages")){
    const links = document.querySelectorAll("a[href='/higher_ed_playbook_messages.html']")
    links.forEach(link => link.classList.add("active"));  
    await displayDash(higherEdPlaybook_messages_ids);
  }else if (window.location.pathname.startsWith("/LetsGrowMI/YouthPoll")){
    await displayDash(letsGrowMI_ids);
  }else if (window.location.pathname.startsWith("/InsideHigherEd/FlashSurvey1")){
    await displayDash(insideHigherEd_ids);
  }else if (window.location.pathname.startsWith("/InsideHigherEd/AnnualSurvey")){
    await displayDash(insideHigherEdAnnualSurvey_ids);
  }else{ //higherED
    await displayDash(higherEd_ids);
  }
})();

const observer = new IntersectionObserver(entries => {

  entries.forEach(entry => {
    const id = entry.target.getAttribute('id');
    if (entry.intersectionRatio > 0.75) {
      document.querySelector(`nav li a[href="#${id}"]`).parentElement.classList.add('active');
    } else {
      document.querySelector(`nav li a[href="#${id}"]`).parentElement.classList.remove('active');
    }
  });
}, {threshold: 0.75});

// Track all sections that have an `id` applied
const sections = document.querySelectorAll('section[id]').forEach((section) => {
  observer.observe(section);
});


// FUNCTIONS BELOW // 

// create generic function to populate an array with all nescessary specifications for any set of dashboard ids
// later iterations can take specific specifications as arguments, if we want diferent dashboards to have different settings
function populateChartArray(ids){
  // ids = list of dashboard names corresponding to html id and mongoDB chart ids (strings) ex: ["name_id_dashboard",["7689aff5-6ea5-4471-a412-3d4f51cce24f","0689aff5-6ea5-4471-a412-3d4f51cce24f"]]
  // returns an list of dashboard names and arrays with created charts ex: ["name_id_dashboard",[chart1,chart2]]

  const arr = [] // intialize array to be returned

  // loop over each dashboard (dashboards can have multiple charts to displayed side by side)
  for(var i=0; i < ids.length;i++){
    const initialized_charts = [] // create list to store initialized charts for the current dashboard 

    // loop over charts in this dashboard and create initialized charts
    for(var j=0; j < ids[i][1].length; j++){
      // console.log(ids[i][0])
      var chart = sdk.createChart({
        chartId: ids[i][1][j],
        theme: "light",
        widthMode: "scale",
        height: "68vh",
        heightMode: "scale",
        showAttribution: false,
        autoRefresh: false,
      });

      if(ids[i][0] === "sample_size_chart"){
         chart = sdk.createChart({
          chartId: ids[i][1][j],
          theme: "light",
          width: "13vh",
          widthMode: "scale",
          height: "11vh",
          heightMode: "scale",
          showAttribution: false,
          autoRefresh: false,
        });
      }
    
      initialized_charts.push(chart); // add each initialized chart to the list initialized_charts 
    }
    arr.push([ids[i][0],initialized_charts] ) // push the name of the dashboard and all initialized charts to the final array (ex: ['name_id_dashboard', [init_chart_1, init_chart_2, ... ]])
  }
  return arr
}

async function renderCharts(arr){

  const promises = [];

  for(var i = 0; i < arr.length; i++){ // loop over target divs

    const dash_name = arr[i][0] // get name of target div (without chart number)
    
    for(var j = 0; j < arr[i][1].length; j++){ // loop over charts in the current target div
      
      const curr_chart = arr[i][1][j] // get chart

      promises.push(curr_chart.render(document.getElementById(dash_name+`_${j+1}`))); // render chart in the target div

    }
  }
  const renderResults = await Promise.allSettled(promises)
  return renderResults
}


function getFilters() {
  // Function that checks the filters set in the dropdown and returns an object that can be passed to MongoDB Charts

  const dropdowns = document.querySelectorAll('[name="audience"]'); // find all the dropdowns
  let curr_filter = {} // set up object that we can add filters to

  // Loop through each dropdown and add filter values to curr_filter
  // each dropdown has an atribute dropdown.value" and dropdown.id
  // dropdown.id MUST BE the field that is being featured (ex: Race)
  // dropdown.value MUST BE the filter value (ex: Asian) 
  dropdowns.forEach((dropdown) => {
    //only add a filter is the dropdown value is not empty
    // console.log(dropdown)
    if (dropdown.value !== "") {
      if (dropdown.value === "Joe Biden" && dropdown.id === "2020Vote") {
        curr_filter[dropdown.id] = {$in: ["Joe Biden","Biden"]};
      } else if (dropdown.value === "Donald Trump" && dropdown.id === "2020Vote") {
        curr_filter[dropdown.id] = {$in: ["Donald Trump","Trump"]};
      } else if (dropdown.value === "Fourth Year" && dropdown.id === "Year") {
        curr_filter[dropdown.id] = {$in: ["Fourth Year","Fourth year"]};
      } else if (dropdown.value === "Not Registered" && dropdown.id === "VOTERREG") {
        curr_filter[dropdown.id] = {$in: ["Not Registered","Not registered"]};
      }else if (dropdown.dataset.filtertype === "int") { 
        // filtering on numbers so we need a range (inclusive)
        // only works on integers now 
        // only one bound can unbounded (unb), other must be specified
        const lowerBound = dropdown.value.split("-")[0]
        const upperBound = dropdown.value.split("-")[1]
        if(upperBound === "unb"){
          curr_filter[dropdown.id] = {"$gte": parseInt(lowerBound,10)}
        } else if(lowerBound === "unb"){
          curr_filter[dropdown.id] = {"$lte": parseInt(upperBound,10)}
        } else{
          curr_filter[dropdown.id] = {"$gte": parseInt(lowerBound,10), "$lte": parseInt(upperBound,10)}
        }
      }else if (dropdown.dataset.filtertype === "mult") { 
        // filtering to include multiple values (or)
        // option.value = filter1||filter2||filter3 (continue for as many filter values as you want)
        const filterValues = dropdown.value.split("||")
        curr_filter[dropdown.id] = {$in: filterValues};
      } else {
        curr_filter[dropdown.id] = {$eq: dropdown.value};
      }
    }
  });
  console.log(curr_filter)
  return curr_filter
}

function setFilterListeners(arr){

  const dropdowns = document.getElementsByName("audience");
  for (var x = 0; x < dropdowns.length; x++){
    var dropdown = dropdowns[x]
    dropdown.addEventListener("change", async () => {

      // hide sample size during reload if in inside higher ed or lets grow MI
      if(window.location.pathname.startsWith("/InsideHigherEd") || window.location.pathname.startsWith("/LetsGrowMI/YouthPoll")){ 
        setLoading(true)
        
        // const sampleSizeLocation = document.getElementById("sample-size-number")
        // sampleSizeLocation.innerText = "--"
      }

      // get filters
      const curr_filter = getFilters()

      for(var i = 0; i < arr.length; i++){ // loop over target divs

        // reset percentage on click workaround in IHE/MI dashboard because the sample size is changing
        const curr_chart_name = arr[i][0]
        const curr_chart_name_list = curr_chart_name.split("-")
        if (curr_chart_name_list[curr_chart_name_list.length - 2] == "pct" && (window.location.pathname.startsWith("/InsideHigherEd") || window.location.pathname.startsWith("/LetsGrowMI/YouthPoll"))){
          const message_box = document.getElementById(curr_chart_name + "-message")
          const message_type = message_box.getElementsByTagName("span")[0]
          message_box.childNodes[1].nodeValue = "(click on chart to show)" 
          message_type.innerText = "Percent of population who agree with the following statements: "
        }

        for(var j = 0; j < arr[i][1].length; j++){ // loop over charts in the current target div
          const curr_chart = arr[i][1][j] // get chart

          if(curr_chart_name == "sample_size_chart"){
            await curr_chart.setFilter(curr_filter);
            await curr_chart.refresh();
            var sampleSize = await getSampleSizeFromChart(curr_chart);
            // console.log("data:", data);
            if(window.location.pathname.startsWith("/InsideHigherEd") || window.location.pathname.startsWith("/LetsGrowMI/YouthPoll")){
              setLoading(false, sampleSize)
              
              // const sampleSizeLocation = document.getElementById("sample-size-number")
              // sampleSizeLocation.innerText = sampleSize.toString()
            } 
          }else{
            curr_chart.setFilter(curr_filter);
          }
        }
      }
    })
  }
}

async function getSampleSize(arr, chartName) {
  let sampleSize;
  const chartData = arr.find(([name]) => name === "sample_size_chart");

  if (!chartData) return sampleSize;

  const currChart = chartData[1][0];

  //adding implicit filter on q10 based of condidtional survey logic
  if (chartName === "destination-pct-x") {
    const curr_filters = getFilters();
    const curr_filters_temp = { ...curr_filters, ["Do you plan to continue living in [QID59-ChoiceGroup-SelectedChoices] for the foreseeable future?"]: {$eq: "No, I plan to move in the near future"} };
    
    console.log("Setting filter:", curr_filters_temp); // Log the filter being set
    await currChart.setFilter(curr_filters_temp);
    await currChart.refresh();
    sampleSize = await getSampleSizeFromChart(currChart);
    
    console.log("Reverting to original filter:", curr_filters); // Log the filter being set
    await currChart.setFilter(curr_filters); // revert back to original filter
  } else {
    currChart.refresh();
    sampleSize = await getSampleSizeFromChart(currChart);
  }

  return sampleSize;
}

async function getSampleSizeFromChart(chart) {
  const sampleSizeData = await chart.getData();
  const sampleSize = parseInt(sampleSizeData["documents"][0].value);
  console.log("sample size", sampleSize)
  return sampleSize;
}

function calculateMarginOfError(sampleSize) {
  const zScore = 1.96; // Z-score for 95% confidence level
  const p = 0.52; // Population proportion
  const q = 1 - p; // 1 - Population proportion
  const n = sampleSize; // Sample size

  const marginOfError = zScore * Math.sqrt((p * q) / n);
  return marginOfError;
}

function setLoading(isLoading, sampleSize) {
// Call setLoading(true) when you start loading
// Call setLoading(false) when loading is finished and you're ready to display the number
  const loadingCircleSample = document.getElementById('loading-circle-sample');
  const loadingCircleMOC = document.getElementById('loading-circle-margin');
  const sampleSizeNumber = document.getElementById('sample-size-number');
  const MOCnumber = document.getElementById('MOC-number');
  if (isLoading) {
    loadingCircleSample.style.display = 'block';
    loadingCircleMOC.style.display = 'block';
    sampleSizeNumber.style.display = 'none';
    MOCnumber.style.display = 'none';
  } else {
    loadingCircleSample.style.display = 'none';
    loadingCircleMOC.style.display = 'none';
    sampleSizeNumber.innerText = sampleSize.toString()
    console.log(Math.round(calculateMarginOfError(sampleSize) * 100).toString() + "%")
    console.log(Math.round(calculateMarginOfError(sampleSize) * 100).toString())
    MOCnumber.innerText = Math.round(calculateMarginOfError(sampleSize) * 100).toString() + "%";
    sampleSizeNumber.style.display = 'block';
    MOCnumber.style.display = 'block';
  }
}

// async function setSampleSize(arr) {
//   setLoading(true)
//   const sampleSize = await getSampleSize(arr)
//   setLoading(false, sampleSize)
// }

// generic function to display dashboards/charts
async function displayDash(ids){
  // ids = chart ids and div targets/groupings 
  //       structure must be a list of dashboard names corresponding to HTML id of the target div and mongoDB chart ids (strings) 
  //       can have list of 2 chart ids if placing two charts side by side
  //       ex: [["name_id_dashboard",["7689aff5-6ea5-4471-a412-3d4f51cce24f","0689aff5-6ea5-4471-a412-3d4f51cce24f"]],
  //            ["favorability_dashbaord",["2689aff5-6ea5-4471-a412-3d4f51cce24f","9689aff5-6ea5-4471-a412-3d4f51cce24f"]]]
  //
  // renders charts at corresponding divs and handles changes in filtering
  
  const arr = populateChartArray(ids) // convert chart ids into created chart from MongoDB 

  await renderCharts(arr)
  setFilterListeners(arr)

  // set sample size using chart data instead of embedding
  if (window.location.pathname.startsWith("/InsideHigherEd") || window.location.pathname.startsWith("/LetsGrowMI/YouthPoll")){
    var sampleSize = await getSampleSize(arr);
    setLoading(false, sampleSize)

    // const sampleSize = await getSampleSize(arr)
    // // console.log(sampleSize)
    // const sampleSizeLocation = document.getElementById("sample-size-number")
    // sampleSizeLocation.innerText = sampleSize.toString()
  }

  // below should be streamlined 
  // eventually want to include information on what event listeners we want in the ids section

  // add listener for IHE percents
  // note that we also reset this menu in set event listeners so that the percent resets when the sample size changes
  if (window.location.pathname.startsWith("/InsideHigherEd") || window.location.pathname.startsWith("/LetsGrowMI/YouthPoll")){
    for(var i = 0; i < arr.length; i++){
      const curr_chart_name = arr[i][0]

      const curr_chart_name_list = curr_chart_name.split("-")
      if (curr_chart_name_list[curr_chart_name_list.length - 2] == "pct" ){
        const curr_chart = arr[i][1][0];
        await curr_chart.addEventListener("click", async (payload) => {
          
          const sampleSize = await getSampleSize(arr);
          let axis = curr_chart_name_list[curr_chart_name_list.length - 1] // depending on vertical or horizontal bar chart, set in ids (ex: affordability-pct-y for a vertical chart)

          const numRespondents = parseInt(payload.data[axis].value); 
          let statement 
          if (window.location.pathname.startsWith("/InsideHigherEd")){ // have to swap axis to get label for IHE (need to unify at some point)
            axis = (axis === 'x') ? 'y' : 'x';
            statement = payload.data[axis].value
          } else {
            statement = payload.data[axis].label
          }

          // console.log(curr_chart_name + "-message")
          // console.log(payload)
          // console.log("data", payload.data[curr_chart_name_list[curr_chart_name_list.length - 1]])

          const message_box = document.getElementById(curr_chart_name + "-message")
          const message_type = message_box.getElementsByTagName("span")[0]
          message_box.childNodes[1].nodeValue = Math.round(numRespondents / sampleSize * 100) + "%" 
          message_type.innerText = statement + ": "
        })
      }
    }
  }

  // add listener for messages examples
  if (window.location.pathname.startsWith("/higher_ed_playbook_messages")){
    for(var i = 0; i < arr.length; i++){ 
      const dash_name = arr[i][0]
      for(var j = 0; j < arr[i][1].length; j++){ 
        const curr_chart = arr[i][1][j]
        await curr_chart.addEventListener("click", (payload) => {
          // console.log(payload)
          const message_box = document.getElementById(dash_name+"-message")
          const message_type = message_box.getElementsByTagName("span")[0]
          message_box.childNodes[1].nodeValue = payload.data.y.value
          message_type.innerText = payload.data.y.label + ": "
          });
        }
      }
    }
}



async function displayWorkplaceDash(sdk){
  // // Read https://dochub.mongodb.org/core/charts-dashboards-embedded-dashboard-options for more options

  const priorities_dashboard = sdk.createDashboard({
    dashboardId: "15a5e11b-e58c-4e33-9441-4d3caf36ba3e",
    theme: "light",
    widthMode: "scale",
    height: "68vh",
    heightMode: "scale",
    showAttribution: false,
    autoRefresh: false,
  });

  const culture_dashboard = sdk.createDashboard({
    dashboardId: "bac72a29-e5d5-4592-a796-3581d809cfdd",
    theme: "light",
    height: "68vh",
    widthMode: "scale",
    heightMode: "scale",
    showAttribution: false,
    autoRefresh: false,
  });

  const in_person_dashboard = sdk.createDashboard({
    dashboardId: "6f3fd84e-c8bc-4d30-9e10-fb9d4aef7aad",
    theme: "light",
    height: "68vh",
    widthMode: "scale",
    heightMode: "scale",
    showAttribution: false,
    autoRefresh: false,
  });


  const working_dashboard = sdk.createDashboard({
    dashboardId: "2d01261b-688c-4573-89af-431ee4d5bf31",
    theme: "light",
    height: "68vh",
    widthMode: "scale",
    heightMode: "scale",
    showAttribution: false,
    autoRefresh: false,
  });


  const recruiting_dashboard = sdk.createDashboard({
    dashboardId: "64f4ffb2-9874-412d-854c-d3b8cbfad62f",
    theme: "light",
    height: "68vh",
    widthMode: "scale",
    heightMode: "scale",
    showAttribution: false,
    autoRefresh: false,
  });

  const top_companies_dashboard = sdk.createDashboard({
    dashboardId: "799fb145-d501-4c3e-b37b-43e61c7e41f6",
    theme: "light",
    height: "68vh",
    widthMode: "scale",
    heightMode: "scale",
    showAttribution: false,
    autoRefresh: false,
  });

  await  top_companies_dashboard.render(document.getElementById("top_companies_dashboard"));
  await  priorities_dashboard.render(document.getElementById("priorities_dashboard"));
  await  culture_dashboard.render(document.getElementById("culture_dashboard"));
  await  in_person_dashboard.render(document.getElementById("in_person_dashboard"));
  await  working_dashboard.render(document.getElementById("working_dashboard"));
  await  recruiting_dashboard.render(document.getElementById("recruiting_dashboard"));
}

async function logOut() {
  // console.log("data currentUser", client.currentUser.customData);
  await client.currentUser.logOut().then(() => {
    window.location.href = "/";
  });
}



// SAVING FOR WHEN I FIX THE HIGHER ED EXAMPLE MESSAGES SECTION 
// for(var i = 0; i < arr.length; i++){ // loop over target divs

  //   const dash_name = arr[i][0] // get name of target div (without chart number)
    
  //   for(var j = 0; j < arr[i][1].length; j++){ // loop over charts in the current target div
      
  //     const curr_chart = arr[i][1][j] // get chart
      
  //     // Adding listener for message section
  //     if (window.location.pathname.startsWith("/higher_ed_playbook_messages")){
  //       //running await here only so that messaging payload works
  //       await curr_chart.render(document.getElementById(dash_name+`_${j+1}`)); // render chart in the target div
  //       await curr_chart.addEventListener("click", (payload) => {
  //         console.log(payload)
  //         const message_box = document.getElementById(dash_name+"-message")
  //         const message_type = message_box.getElementsByTagName("span")[0]
  //         message_box.childNodes[1].nodeValue = higherEdPlaybook_message_examples[dash_name][payload.data.x.value]
  //         message_type.innerText = payload.data.x.value + ": "
  //         message_type.style.color = payload.target.fill
  //       });
  //     }else{
  //        curr_chart.render(document.getElementById(dash_name+`_${j+1}`)); // render chart in the target div
  //     }

  //   }
  // }